import { Box, Flex } from '@/ui';
import { ACCENT, BAR } from './constants';

// Seven equal full-height day columns, side by side — the seven-column week
// (PrintableWeek). The split planner week renders WeekSplitThumbnail instead.
export const WeekColumnsThumbnail = () => (
  <Flex gap="3px" h="full" w="full">
    {Array.from({ length: 7 }).map((_, i) => (
      <Flex direction="column" flex={1} gap="3px" key={i}>
        <Box bg={BAR} borderRadius="1px" flexShrink={0} h="4px" opacity={0.6} />
        <Box
          bg={i === 2 ? ACCENT : BAR}
          borderRadius="2px"
          flex={1}
          opacity={i === 2 ? 0.55 : 0.35}
        />
      </Flex>
    ))}
  </Flex>
);
